/**
 * @generated SignedSource<<e2c0eecf79f42e1ab0d045d504c135cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CandidateLoginQuery$variables = Record<PropertyKey, never>;
export type CandidateLoginQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CandidateLogin_query">;
};
export type CandidateLoginQuery = {
  response: CandidateLoginQuery$data;
  variables: CandidateLoginQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CandidateLoginQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CandidateLogin_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CandidateLoginQuery",
    "selections": [
      {
        "alias": "company",
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameFriendly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "fitIn",
                    "value": true
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": "url(fitIn:true)"
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fdef870da824e857faec28a761ffc933",
    "id": null,
    "metadata": {},
    "name": "CandidateLoginQuery",
    "operationKind": "query",
    "text": "query CandidateLoginQuery {\n  ...CandidateLogin_query\n}\n\nfragment CandidateLogin_query on Query {\n  company: companyDomainName {\n    id\n    ...CompanyLogo_company\n  }\n}\n\nfragment CompanyLogo_company on Company {\n  nameFriendly\n  logo {\n    url(fitIn: true)\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff436d8cecb277818f16afd38af56eac";

export default node;
